var map = {
	"./add-outline.svg": "Mvwl",
	"./add-solid.svg": "ng9N",
	"./adjust.svg": "f0Lx",
	"./airplane.svg": "zrHA",
	"./album.svg": "iemT",
	"./align-center.svg": "7x4r",
	"./align-justified.svg": "bCWH",
	"./align-left.svg": "nmdu",
	"./align-right.svg": "rbqg",
	"./anchor.svg": "y3Q+",
	"./announcement.svg": "5gV5",
	"./apparel.svg": "VNEQ",
	"./arrow-down.svg": "EfRz",
	"./arrow-left.svg": "fG6k",
	"./arrow-outline-down.svg": "qKeT",
	"./arrow-outline-left.svg": "iHda",
	"./arrow-outline-right.svg": "qREX",
	"./arrow-outline-up.svg": "2M9t",
	"./arrow-right.svg": "Djjo",
	"./arrow-thick-down.svg": "qyqx",
	"./arrow-thick-left.svg": "xc0F",
	"./arrow-thick-right.svg": "n6NX",
	"./arrow-thick-up.svg": "6Hch",
	"./arrow-thin-down.svg": "q0cU",
	"./arrow-thin-left.svg": "VLmQ",
	"./arrow-thin-right.svg": "NHmt",
	"./arrow-thin-up.svg": "5P9i",
	"./arrow-up.svg": "yd3i",
	"./artist.svg": "3uBm",
	"./at-symbol.svg": "mL5Z",
	"./attachment.svg": "NrYI",
	"./backspace.svg": "GUw5",
	"./backward-step.svg": "Ff2q",
	"./backward.svg": "WzrY",
	"./badge.svg": "4aSZ",
	"./battery-full.svg": "9lhf",
	"./battery-half.svg": "Nt47",
	"./battery-low.svg": "8PSk",
	"./beverage.svg": "ldIT",
	"./block.svg": "mRNp",
	"./bluetooth.svg": "6pOZ",
	"./bolt.svg": "rYdG",
	"./book-reference.svg": "WH1q",
	"./bookmark copy 2.svg": "N47Y",
	"./bookmark copy 3.svg": "XiHy",
	"./bookmark-outline-add.svg": "ObYp",
	"./bookmark-outline.svg": "Vkl4",
	"./bookmark.svg": "RFNA",
	"./border-all.svg": "/F6E",
	"./border-bottom.svg": "T7t5",
	"./border-horizontal.svg": "VSrn",
	"./border-inner.svg": "tsIe",
	"./border-left.svg": "xhLM",
	"./border-none.svg": "kTpy",
	"./border-outer.svg": "/HGx",
	"./border-right.svg": "8zbS",
	"./border-top.svg": "11dx",
	"./border-vertical.svg": "Eh+t",
	"./box.svg": "q+H5",
	"./brightness-down.svg": "Mesx",
	"./brightness-up.svg": "3Nmx",
	"./browser-window-new.svg": "4SME",
	"./browser-window-open.svg": "3Luv",
	"./browser-window.svg": "KWUT",
	"./bug.svg": "K2Yc",
	"./buoy.svg": "O2UJ",
	"./calculator.svg": "lzjH",
	"./calendar.svg": "wSOt",
	"./camera.svg": "Hhna",
	"./chart-bar.svg": "i3Ud",
	"./chart-pie.svg": "l5OP",
	"./chart.svg": "rqEg",
	"./chat-bubble-dots.svg": "ICq0",
	"./checkmark-outline.svg": "Ry6O",
	"./checkmark.svg": "g9vY",
	"./cheveron-down.svg": "nTFI",
	"./cheveron-left.svg": "xhX/",
	"./cheveron-outline-down.svg": "d8td",
	"./cheveron-outline-left.svg": "nKio",
	"./cheveron-outline-right.svg": "H+ll",
	"./cheveron-outline-up.svg": "+RX6",
	"./cheveron-right.svg": "q+8l",
	"./cheveron-up.svg": "g9U3",
	"./clipboard.svg": "Tcti",
	"./close-outline.svg": "M0m/",
	"./close-solid.svg": "bjS6",
	"./close.svg": "YimB",
	"./cloud-upload.svg": "kic3",
	"./cloud.svg": "9A3q",
	"./code.svg": "o/vE",
	"./coffee.svg": "/sdZ",
	"./cog.svg": "/GZE",
	"./color-palette.svg": "l7ks",
	"./compose.svg": "Syrq",
	"./computer-desktop.svg": "swDP",
	"./computer-laptop.svg": "zk2E",
	"./conversation.svg": "Ppfz",
	"./copy.svg": "yFwE",
	"./credit-card.svg": "y9+L",
	"./currency-dollar.svg": "YBOB",
	"./dashboard.svg": "Fu9G",
	"./date-add.svg": "yUyb",
	"./dial-pad.svg": "oljx",
	"./directions.svg": "HJjT",
	"./document-add.svg": "iNdt",
	"./document.svg": "nW5R",
	"./dots-horizontal-double.svg": "NnW0",
	"./dots-horizontal-triple.svg": "Ay9B",
	"./download-02.svg": "dbOt",
	"./download.svg": "L23+",
	"./duplicate.svg": "Ua15",
	"./edit-copy.svg": "elxd",
	"./edit-crop.svg": "Onq/",
	"./edit-cut.svg": "sSyi",
	"./edit-pencil.svg": "xZnK",
	"./education.svg": "eeu4",
	"./envelope.svg": "O6si",
	"./exclamation-outline.svg": "Gji/",
	"./exclamation-solid.svg": "vBq0",
	"./explore.svg": "VwiK",
	"./factory.svg": "SsZH",
	"./fast-forward.svg": "64OS",
	"./fast-rewind.svg": "3HNs",
	"./film.svg": "ASww",
	"./filter.svg": "pa7B",
	"./flag.svg": "vgne",
	"./flashlight.svg": "9Lmj",
	"./folder-outline-add.svg": "Mfmp",
	"./folder-outline.svg": "jqTH",
	"./folder.svg": "lEMi",
	"./format-bold.svg": "pMI6",
	"./format-font-size.svg": "MsBH",
	"./format-italic.svg": "73U+",
	"./format-text-size.svg": "1o0y",
	"./format-underline.svg": "66fk",
	"./forward-step.svg": "JjGq",
	"./forward.svg": "tAHY",
	"./gift.svg": "9GCo",
	"./globe.svg": "4KRz",
	"./hand-stop.svg": "PL2e",
	"./hard-drive.svg": "DIMh",
	"./headphones.svg": "Ms+O",
	"./heart.svg": "/g9n",
	"./home.svg": "0qL9",
	"./hot.svg": "SgJ3",
	"./hour-glass.svg": "/249",
	"./inbox-check.svg": "dNRO",
	"./inbox-download.svg": "OeiT",
	"./inbox-full.svg": "rzfy",
	"./inbox.svg": "2d4n",
	"./indent-decrease.svg": "8KQ4",
	"./indent-increase.svg": "tizr",
	"./information-outline.svg": "Hx6B",
	"./information-solid.svg": "cmlC",
	"./key.svg": "7KsS",
	"./keyboard.svg": "QTHP",
	"./layers.svg": "GLJE",
	"./library.svg": "nuv2",
	"./light-bulb.svg": "VNLr",
	"./link.svg": "h3IK",
	"./list-add.svg": "Q/wt",
	"./list-bullet.svg": "aKa1",
	"./list.svg": "t/Jy",
	"./load-balancer.svg": "k4rj",
	"./location-current.svg": "ERhb",
	"./location-food.svg": "7nbi",
	"./location-gas-station.svg": "C/J2",
	"./location-hotel.svg": "IGfr",
	"./location-marina.svg": "xFVW",
	"./location-park.svg": "W15R",
	"./location-restroom.svg": "F8YX",
	"./location-shopping.svg": "AptT",
	"./location.svg": "X4zK",
	"./lock-closed.svg": "10aR",
	"./lock-open.svg": "wIv0",
	"./map.svg": "f98m",
	"./menu.svg": "7c/M",
	"./mic.svg": "21fa",
	"./minus-outline.svg": "NRue",
	"./minus-solid.svg": "TQve",
	"./mobile-devices.svg": "QT/o",
	"./mood-happy-outline.svg": "fgRv",
	"./mood-happy-solid.svg": "if5Y",
	"./mood-neutral-outline.svg": "Y0dM",
	"./mood-neutral-solid.svg": "FoeU",
	"./mood-sad-outline.svg": "1w2P",
	"./mood-sad-solid.svg": "oGjH",
	"./mouse.svg": "A+7f",
	"./music-album.svg": "C2l1",
	"./music-artist.svg": "2oXC",
	"./music-notes.svg": "gbY/",
	"./music-playlist.svg": "Zw54",
	"./navigation-more.svg": "S6i7",
	"./network.svg": "kGzZ",
	"./news-paper.svg": "aCUI",
	"./notification.svg": "Xs7s",
	"./notifications-outline.svg": "Kv7s",
	"./notifications.svg": "Gq1N",
	"./paste.svg": "k9Gt",
	"./pause-outline.svg": "xIqO",
	"./pause-solid.svg": "TCks",
	"./pause.svg": "fSHj",
	"./pen-tool.svg": "Ar4h",
	"./phone.svg": "uqeO",
	"./photo.svg": "GBy9",
	"./php-elephant.svg": "Zpu6",
	"./pin.svg": "Mmtg",
	"./play-outline.svg": "jr+h",
	"./play.svg": "ds9k",
	"./playlist.svg": "Pzjr",
	"./plugin.svg": "8nGX",
	"./portfolio.svg": "Hvcl",
	"./printer.svg": "zXNa",
	"./pylon.svg": "LYsi",
	"./question.svg": "HCEc",
	"./queue.svg": "aBus",
	"./radar copy 2.svg": "QXDU",
	"./radar.svg": "mCUU",
	"./radio.svg": "N9yx",
	"./refresh.svg": "fhyJ",
	"./reload.svg": "+J7W",
	"./reply-all.svg": "LWwc",
	"./reply.svg": "JPCd",
	"./repost.svg": "FaO6",
	"./save-disk.svg": "Bkhi",
	"./screen-full.svg": "Rdt2",
	"./search.svg": "on31",
	"./send.svg": "uIq0",
	"./servers.svg": "/9ce",
	"./share-01.svg": "CEuZ",
	"./share-02.svg": "T0Nw",
	"./share-alt.svg": "+M5k",
	"./share.svg": "1mtu",
	"./shield.svg": "xNuR",
	"./shopping-cart.svg": "Xl+N",
	"./show-sidebar.svg": "ZNMm",
	"./shuffle.svg": "XCVD",
	"./stand-by.svg": "QxRt",
	"./star-full.svg": "e6yP",
	"./station.svg": "60oJ",
	"./step-backward.svg": "D20z",
	"./step-forward.svg": "hPk5",
	"./stethoscope.svg": "i8KJ",
	"./store-front.svg": "wZuk",
	"./stroke-width.svg": "XlvX",
	"./subdirectory-left.svg": "TMGI",
	"./subdirectory-right.svg": "R+YT",
	"./swap.svg": "L09o",
	"./tablet.svg": "2amN",
	"./tag.svg": "qnJ1",
	"./target.svg": "CVWn",
	"./text-box.svg": "oDJx",
	"./text-decoration.svg": "UQU+",
	"./thermometer.svg": "bl+A",
	"./thumbs-down.svg": "44b2",
	"./thumbs-up.svg": "K725",
	"./ticket.svg": "+zix",
	"./time.svg": "tMx5",
	"./timer.svg": "++XA",
	"./tools copy.svg": "+X4I",
	"./translate.svg": "Cdca",
	"./trash.svg": "mv64",
	"./travel-bus.svg": "7mQ3",
	"./travel-car.svg": "dI+W",
	"./travel-case.svg": "LcuV",
	"./travel-taxi-cab.svg": "ncPm",
	"./travel-train.svg": "vx1A",
	"./travel-walk.svg": "+tM+",
	"./travel.svg": "Pmpe",
	"./trophy.svg": "YAtM",
	"./tuning.svg": "6l03",
	"./upload.svg": "tY1w",
	"./usb.svg": "wvlD",
	"./user-add.svg": "NzX8",
	"./user-group.svg": "Go8q",
	"./user-solid-circle.svg": "6YJQ",
	"./user-solid-square.svg": "CPOP",
	"./user.svg": "5bwK",
	"./vector.svg": "RuG0",
	"./video-camera.svg": "bsXR",
	"./view-carousel.svg": "GMBD",
	"./view-column.svg": "SaFr",
	"./view-hide.svg": "ddTF",
	"./view-list.svg": "kc7E",
	"./view-show.svg": "eujw",
	"./view-tile.svg": "+4ry",
	"./volume-down.svg": "fGnA",
	"./volume-mute.svg": "eXnl",
	"./volume-off.svg": "npSE",
	"./volume-up.svg": "pmgM",
	"./wallet.svg": "8yas",
	"./watch.svg": "dPvT",
	"./window-new.svg": "g65l",
	"./window-open.svg": "4Wcj",
	"./window.svg": "OMmH",
	"./wrench.svg": "zNDQ",
	"./yin-yang.svg": "mJO1",
	"./zoom-in.svg": "Nq0y",
	"./zoom-out.svg": "661p"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XTbA";